import React from 'react';
import './App.css'
import MainLP from './MainLP';


function App() {

  return (
    <MainLP />
  );
}

export default App;
